var path = '/modules/contacts/views/pages/details/messages.tpl.html';
var html = "<contact-messages ng-if=\"vm.contact\" contact=\"vm.contact\"></contact-messages>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/contacts/views/pages/details/messages.tpl.html
// module id = 2076
// module chunks = 1